import React from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const NombreProductoTooltip = ({ nombreProducto, idProducto }) => {
    return (
        <>
            <span
                className="truncate font-bold text-black-500"
                data-tooltip-id={`tooltip-nombre-producto-${idProducto}`}
                data-tooltip-content={nombreProducto}
            >
                {nombreProducto.length > 30
                    ? `${nombreProducto.substring(0, 30)}...`
                    : nombreProducto}
            </span>
            <Tooltip
                id={`tooltip-nombre-producto-${idProducto}`}
                place="top"
                style={{
                    maxWidth: '400px', // Ajusta el ancho máximo
                    wordWrap: 'break-word', // Ajusta el texto largo
                    whiteSpace: 'normal', // Permite saltos de línea
                    zIndex: 9999, // Asegura que el tooltip esté por encima de otros elementos
                    fontSize: '14px', // Tamaño de fuente
                }}
            />
        </>
    );
};

export default NombreProductoTooltip;
